export const help_me_choose_intermediate_event = (data) => ({
    event: data.event || null,
    eventCategory: data.eventCategory || null,
    eventAction: data.eventAction || null,
    step: data.step + 1 || 0,
    question: data.question || null,
    answers: data.answers || null,
})
